<template>
  <v-card flat width="100%" color="transparent">
    <v-card
      color="transparent"
      width="50%"
      v-if="!$vuetify.breakpoint.mobile"
      class="mx-auto"
    >
      <v-row no-gutters>
        <v-col>
          <v-img
            src="@/assets/profilePic.png"
            lazy-src="@/assets/profilePic.png"
            width="300"
            class="rounded-lg"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
        <v-col>
          <div class="mt-16">
            <v-card-title>Hello there !</v-card-title>
            <v-card-text>
              Hi, I'm Abel Sekwa Sekwala. I'm a full-stack web developer with a passion
              for building user-friendly and visually appealing applications. I'm
              proficient in a variety of technologies, including Vue.js, Vuex, Nuxt,
              Vuetify, Laravel, Cordova, MySQL, PHP, JavaScript, AJAX, and jQuery.
            </v-card-text>
            <v-card-text>
              I'm always looking for new challenges and opportunities to learn and grow.
              I'm also a team player and I'm always willing to help others.
            </v-card-text>
            <v-card-text>
              I'm confident that my skills and experience would be a valuable asset to
              your team. I'm eager to show you what I can do.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                target="_blank"
                class="ma-2"
                outlined
                small
                fab
                color="orange"
                href="https://www.linkedin.com/in/abel-sekwala-ba8544243"
              >
                <v-icon>mdi mdi-linkedin</v-icon>
              </v-btn>
              <v-btn
                target="_blank"
                class="ma-2"
                outlined
                small
                fab
                color="orange"
                href="https://github.com/rootDefault"
              >
                <v-icon>mdi mdi-github</v-icon>
              </v-btn>
              <v-btn
                target="_blank"
                class="ma-2"
                outlined
                small
                fab
                color="orange"
                href="https://instagram.com/root_default?igshid=OGQ5ZDc2ODk2ZA=="
              >
                <v-icon>mdi mdi-instagram</v-icon>
              </v-btn>
              <v-btn
                target="_blank"
                class="ma-2"
                outlined
                small
                fab
                color="orange"
                href="https://www.facebook.com/abel.sekwala.9"
              >
                <v-icon>mdi mdi-facebook</v-icon>
              </v-btn>
            </v-card-actions>
          </div>
        </v-col>
      </v-row>
    </v-card>
    <v-card
      flat
      color="transparent"
      width="90%"
      class="mx-auto"
      v-if="$vuetify.breakpoint.mobile"
    >
      <v-img
        src="@/assets/profilePic.png"
        lazy-src="@/assets/profilePic.png"
        width="200"
        class="mx-auto rounded-lg"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
      <v-card-title>Hello there !</v-card-title>
      <v-card-text>
        Hi, I'm Abel Sekwa Sekwala. I'm a full-stack web developer and mobile app
        developer with a passion for building user-friendly and visually appealing
        applications. I'm proficient in a variety of technologies, including Vue.js, Vuex,
        Nuxt, Vuetify, Laravel, Cordova, MySQL, PHP, JavaScript, AJAX, and jQuery.
      </v-card-text>
      <v-card-text>
        I'm always looking for new challenges and opportunities to learn and grow. I'm
        also a team player and I'm always willing to help others.
      </v-card-text>
      <v-card-text>
        I'm confident that my skills and experience would be a valuable asset to your
        team. I'm eager to show you what I can do.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          target="_blank"
          class="ma-2"
          outlined
          small
          fab
          color="orange"
          href="https://www.linkedin.com/in/abel-sekwala-ba8544243"
        >
          <v-icon>mdi mdi-linkedin</v-icon>
        </v-btn>
        <v-btn
          target="_blank"
          class="ma-2"
          outlined
          small
          fab
          color="orange"
          href="https://github.com/rootDefault"
        >
          <v-icon>mdi mdi-github</v-icon>
        </v-btn>
        <v-btn
          target="_blank"
          class="ma-2"
          outlined
          small
          fab
          color="orange"
          href="https://instagram.com/root_default?igshid=OGQ5ZDc2ODk2ZA=="
        >
          <v-icon>mdi mdi-instagram</v-icon>
        </v-btn>
        <v-btn
          target="_blank"
          class="ma-2"
          outlined
          small
          fab
          color="orange"
          href="https://www.facebook.com/abel.sekwala.9"
        >
          <v-icon>mdi mdi-facebook</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-card>
</template>

<script>
export default {};
</script>

<style></style>
